import { filter, takeUntil } from 'rxjs/operators';
import { Component, Input, OnDestroy, OnInit, ViewChild, HostListener, ElementRef,
  ChangeDetectionStrategy , ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PackageList, updateInfoType, DeviceSubTypeMapping } from '../../shareModel';
import { Subject, combineLatest} from 'rxjs';
import { EditGroupComponent } from '../edit-group/edit-group.component';
import { DeleteGroupComponent } from '../delete-group/delete-group.component';
import {
  BatteryReplacement,
  BtyReplacementParams
} from '../../my-features/battery-replacement/battery-replacement.model';
import { ObjectSharingParam } from '../../my-features/object-sharing/object-sharing.model';
import * as fromMyfeatures from '../../my-features';
import { PreferenceService } from '../../services/preference.service';
import { DialogComponent } from '../../../app/dialog/dialog.component';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { Router, NavigationEnd } from '@angular/router';
import { PlanSettingParams } from 'src/app/my-features/plan/plan-setting.model';
import {TranslateService} from '@ngx-translate/core';
import { User } from '../../models/user';

@Component({
  standalone: false,
  selector: 'app-gridview',
  templateUrl: './gridview.component.html',
  styleUrls: ['./gridview.component.css'],
})

export class GridviewComponent implements OnInit, OnDestroy {
  BRBDexpireNotify = false;
  @Input() selectedTab;
  @Input() selectedView;
  @Input() pageloading;
  @Input() keyWord;
  @Input() sortType;
  deviceList$: Observable<any>;
  deviceGroupList$: Observable<any>;
  deviceSharingList$: Observable<any>;
  // deviceSharingGroupList$: Observable<any>;
  objectSharingParam: ObjectSharingParam = {owner_acode: 0};
  loading = true;
  dataLoadingView = [{}, {}, {}, {}, {}];
  private componentDestroyed = new Subject();
  groupFeature: Boolean;
  batteryReplacementInfo: BatteryReplacement;
  UpdateInfoParam = {} as UpdateInfoModel;
  companionAlert = true;
  deviceListLength: number;
  deviceListData = [];
  deviceListDataStash = [];
  deviceGroupListLength: number;
  deviceGroupListData = [];
  deviceGroupListDataStash = [];
  deviceShareGroupListLength: number;
  deviceShareGroupListData = [];
  deviceShareGroupListDataStash = [];
  deviceSharingListLength: number;
  deviceSharingListData = [];
  deviceSharingListDataStash = [];
  regionAuthDic = [];
  isMsp: Boolean;
  loadRegionTag: Boolean;
  mspRegionFilter;
  region_dic = {};
  clickLock : boolean = false;
  selectDevice = [];
  DeviceSubTypeMapping = DeviceSubTypeMapping;
  filterChildrenItem = [];
  filterChildrenItemShared = [];

  @ViewChild(EditGroupComponent, { static: false }) childEdit: EditGroupComponent;
  @ViewChild(DeleteGroupComponent, { static: false }) childDel: DeleteGroupComponent;
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  constructor(private store: Store<fromStore.State>, private messageService: MessageService, private preferenceService: PreferenceService,
              private ngxService: NgxUiLoaderService,
              private elementRef: ElementRef,
              public changeDetectorRef: ChangeDetectorRef,
              private router: Router,
              private translateService: TranslateService) {

    this.store.select(fromStore.getIsActiveUserModule, PackageList.Companion).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      // const packageCompanion = Boolean(res);
      const packageCompanion = false;
      if (!packageCompanion) {
        this.companionAlert = false;
      }
    });

    // Get Plan Setting Info
    this.store.select(fromStore.getPlanSetting).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        if (this.clickLock) {
          let purchasingPlanList = Object.values(res.entities).filter((i) => i.Status !== 2); // no expired.
          purchasingPlanList = purchasingPlanList.map((item) => {
            return {...item, expirationDate: (item.RemainDay > 0) ? new Date().setDate(new Date().getDate() + item.RemainDay) : 'Expired'};
          });
          const usingPlan = Object.values(purchasingPlanList).find((i) => i.Status === 1);
          if (usingPlan) {
            const dcode_list = [...(Array.isArray(usingPlan.UsingDevices) ? usingPlan.UsingDevices : [])];
            if (this.selectDevice && this.selectDevice.length > 0) {
              this.selectDevice.forEach(i => dcode_list.push(Number(i.dcode)));
            }
            const params: PlanSettingParams = {
              PlanInfoId: parseInt(usingPlan.Id, 10),
              dcodes: dcode_list // convert into number.
            };
            if (params.dcodes.length > usingPlan.NodeTotal) {
              this.childDialog.checkLocked(null, false);
            } else {
              this.childDialog.checkLocked(params, true);
            }
            this.clickLock = false;
          } else { 
            this.childDialog.expiredDialog();
          }
        }
      }
    });

    combineLatest(this.store.select(fromStore.getMspRegionFilter), this.store.select(fromStore.getRegionState), this.store
    .select(fromStore.getMspMemberAuthority)).pipe(takeUntil(this.componentDestroyed)).subscribe(([filter, region, auth]) => {
      this.mspRegionFilter = null;
      if (region.Loaded && !region.Loading) {
        this.region_dic = {};
        Object.values(region.entities).map(r => {
          this.region_dic[r.Id] = r;
        });
        if (auth !== undefined && auth.length > 0) {
          auth.map(r => {
            this.regionAuthDic[r.RegionId] = r;
          });
        }
        if (filter !== null && filter.filterLoaded) {
          // this.loadRegionTag = true
          this.isMsp = filter.isMsp;
          if (filter.isMsp) {
            this.mspRegionFilter = filter.selectedId;
          }
          // if (Object.keys(this.region_dic).length !== 0) {
          //   this.packageSetting();
          // }
          this.packageSetting();
        }
      }
    });

    // Save成功導回dashboard頁面
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.type === updateInfoType.UpdatePlanSetting) {
        if (!res.isLoading && res.isLoaded) {
          if (res.isSaved) {
            this.messageService.add({ severity: 'success', summary: this.translateService.instant('Update Success') });
            const UserParam = { regionIds: this.mspRegionFilter } as User;
            this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
            this.store.dispatch(new fromStore.GetDeviceInfoAction({ regionIds: this.mspRegionFilter }));
            this.store.dispatch(new fromStore.GetGroups({ regionIds: this.mspRegionFilter }));
            this.store.dispatch(
              new fromMyfeatures.GetBatteryReplacements({} as BtyReplacementParams)
            );
            this.store.dispatch(new fromMyfeatures.GetPreferences());
          } else {
            this.messageService.add({ severity: 'error', summary: this.translateService.instant('Update Fail') });
          }
          this.UpdateInfoParam = { ...this.UpdateInfoParam, type: updateInfoType.FreeState };
          this.store.dispatch(new fromMyfeatures.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
        }
      }
    });
  }

  ngOnInit() {
    this.deviceGroupListData = [];
    this.deviceGroupListDataStash = [];
    this.deviceShareGroupListData = [];
    this.deviceShareGroupListDataStash = [];
    this.deviceListLength = 0;
    this.deviceListData = [];
    this.deviceListDataStash = [];
    this.packageSetting();
  }

  // onLoad() {
  //   this.loading = false;
  // }

  triggerEdit(data) {
    this.childEdit.editGroup(data);
    event.stopPropagation();
  }

  triggerDelete(data) {
    this.childDel.deleteGroup(data);
    event.stopPropagation();
  }

  filterChildren(item, is_shared) {
    this.filterChildrenItem = item.filter(i => Object.keys(i.data).length !== 0 && i.data.is_shared === is_shared);
    this.filterChildrenItemShared = item.filter(i => Object.keys(i.data).length !== 0 && i.data.is_shared === is_shared);
    return item.filter(i => Object.keys(i.data).length !== 0 && i.data.is_shared === is_shared);
  }

  packageSetting() {
    this.store.select(fromStore.getIsActiveUserModule, PackageList.Group).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.groupFeature = Boolean(res);
      if (this.groupFeature) {
        // this.deviceList$ = this.store.select(fromStore.getNoGroupDevicesPageView);
        this.store.select(fromStore.getNoGroupDevicesPageView).subscribe(res => {
          this.deviceListLength = 0;
          this.deviceListData = [];
          this.deviceListDataStash = [];
          if (this.isMsp && this.regionAuthDic !== undefined && this.regionAuthDic.length > 0) {
            res.map((i) => {
              if (this.mspRegionFilter !== null) {
                if (this.regionAuthDic[i.regionId] !== undefined && this.regionAuthDic[i.regionId].ViewDevice === 1) {
                  if (i.canTrial === undefined || !i.canTrial) {
                    const cloned = { ...i };
                    this.deviceListData.push(cloned);
                    this.deviceListDataStash.push(cloned);

                  }
                }
              } else {
                const cloned = { ...i };
                this.deviceListData.push(cloned);
                this.deviceListDataStash.push(cloned);
              }
            });
            this.getNoGroupDevicesPageView(this.deviceListData);
            this.getNoGroupDevicesPageView(this.deviceListDataStash);
          } else {
            this.deviceListLength = res.length;
            this.deviceListData = this.sortDeviceGridView(res);
            this.deviceListDataStash = this.sortDeviceGridView(res);
          }
          this.deviceListLength = this.deviceListData.length;

          if (!this.keyWord) {
          } else {
            const filteredDevices = this.deviceListDataStash.filter(item => item.name.toLowerCase().includes(this.keyWord.toLowerCase()));
            this.getNoGroupDevicesPageView(filteredDevices);
          }
        });
        // this.deviceGroupList$ = this.store.select(fromStore.getGroupDevicesPageGridView);
        this.store.select(fromStore.getGroupDevicesPageGridView).subscribe(res => {
          this.deviceGroupListData = [];
          this.deviceGroupListDataStash = [];
          this.deviceShareGroupListData = [];
          this.deviceShareGroupListDataStash = [];
          if (res && res.length > 0) {
            res.map((i) => {
              if (this.isMsp) {
                if (this.regionAuthDic !== undefined && this.regionAuthDic.length > 0 &&
                  this.regionAuthDic[i.data.regionId] !== undefined && this.regionAuthDic[i.data.regionId].ViewDevice === 1) {
                  const device = [];
                  i.children.map((c) => {
                    if (c.data.canTrial === undefined || !c.data.canTrial) {
                      device.push({ ...c, data: { ...c.data } });
                    }
                  });
                  if (!i.data.is_shared) {
                    const group_item = {
                      data: { ...i.data },
                      children: device
                    };
                    this.deviceGroupListData.push(group_item);
                    this.deviceGroupListDataStash.push(group_item);
                  }
                } else {
                  if (i.data.is_shared) {
                    const cloned = {
                      data: { ...i.data },
                      children: (i.children || []).map(c => ({ ...c, data: { ...c.data } })),
                    };
                    this.deviceShareGroupListData.push(cloned);
                    this.deviceShareGroupListDataStash.push(cloned);
                  }
                }
                this.deviceGroupListData = this.sortGroupGridView(this.deviceGroupListData);
                this.deviceShareGroupListData = this.sortGroupGridView(this.deviceShareGroupListData);
              } else {
                if (!i.data.is_shared) {
                  const cloned = {
                    data: { ...i.data },
                    children: (i.children || []).map(c => ({ ...c, data: { ...c.data } })),
                  };
                  this.deviceGroupListData.push(cloned);
                  this.deviceGroupListDataStash.push(cloned);
                } else {
                  const cloned = {
                    data: { ...i.data },
                    children: (i.children || []).map(c => ({ ...c, data: { ...c.data } })),
                  };
                  this.deviceShareGroupListData.push(cloned);
                  this.deviceShareGroupListDataStash.push(cloned);
                }
                this.deviceGroupListData = this.sortGroupGridView(this.deviceGroupListData);
                this.deviceShareGroupListData = this.sortGroupGridView(this.deviceShareGroupListData);
              }
            });

            if (!this.keyWord) {
            } else {
              const filteredGroupDevices = this.deviceGroupListDataStash.map((obj) => {
                const childrenData = obj.children && Array.isArray(obj.children)
                ? obj.children.filter((c) =>
                    c.data && c.data.name && c.data.name.toLowerCase().includes(this.keyWord.toLowerCase())
                  )
                : [];

              return { data: obj.data, children: childrenData };
              });
              this.getGroupDevicesPageGridView(filteredGroupDevices);

              const filteredShareGroupDevices = this.deviceShareGroupListDataStash.map((obj) => {
                const childrenData = obj.children && Array.isArray(obj.children)
                ? obj.children.filter((c) =>
                    c.data && c.data.name && c.data.name.toLowerCase().includes(this.keyWord.toLowerCase())
                  )
                : [];

              return { data: obj.data, children: childrenData };
              });
              this.getShareGroupDevicesPageGridView(filteredShareGroupDevices);
            }

            this.deviceGroupListLength = this.deviceGroupListData.length;
            this.deviceShareGroupListLength = this.deviceShareGroupListData.length;
          }
        });
        // this.deviceSharingList$ = this.store.select(fromStore.getNoGroupShareDevicesPageView);
        this.store.select(fromStore.getNoGroupShareDevicesPageView).subscribe(res => {
          this.deviceSharingListLength = res.length;
          this.deviceSharingListData = this.sortDeviceGridView(res);
          this.deviceSharingListDataStash = this.sortDeviceGridView(res);
          if (!this.keyWord) {
          } else {
            const filteredDevices = this.deviceSharingListDataStash.filter(item => item.name.toLowerCase().includes(this.keyWord.toLowerCase()));
            this.getNoGroupShareDevicesPageView(filteredDevices);
          }
        });
        // this.deviceSharingGroupList$ = this.store.select(fromStore.getGroupShareDevicesPageGridView);
      } else {
        // this.deviceList$ = this.store.select(fromStore.getWithoutGroupFeatureView);
        this.store.select(fromStore.getWithoutGroupFeatureView).subscribe(res => {
          this.deviceListLength = res.length;
          this.deviceListData = this.sortDeviceGridView(res);
          this.deviceListDataStash = this.sortDeviceGridView(res);
          if (!this.keyWord) {
          } else {
            const filteredDevices = this.deviceListDataStash.filter(item => item.name.toLowerCase().includes(this.keyWord.toLowerCase()));
            this.getWithoutGroupFeatureView(filteredDevices);
          }
        });
        // this.deviceSharingList$ = this.store.select(fromStore.getWithoutGroupShareFeatureView);
        this.store.select(fromStore.getWithoutGroupShareFeatureView).subscribe(res => {
          this.deviceSharingListLength = res.length;
          this.deviceSharingListData = this.sortDeviceGridView(res);
          this.deviceSharingListDataStash = this.sortDeviceGridView(res);
          if (!this.keyWord) {
          } else {
            const filteredSharingDevices = this.deviceSharingListDataStash.filter(item => item.name.toLowerCase().includes(this.keyWord.toLowerCase()));
            this.getWithoutGroupShareFeatureView(filteredSharingDevices);
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  displayExpiredDialog(item) {
    if (!this.isMsp) {
      this.clickLock = true;
      this.selectDevice = []
      this.selectDevice.push(item);
      this.store.dispatch(new fromMyfeatures.GetPlanSettings());
      // this.childDialog.expiredDialog(item);
    }
  }

  displayisTrialDialog(item) {
    this.childDialog.isTrialDialog(item);
  }

  rejectShareDevice(item) {
    this.objectSharingParam = {
      ...this.objectSharingParam,
      share_id: item.share_id,
      owner_acode: item.owner_acode,
      is_confirm: false,
    };
    this.store.dispatch(new fromMyfeatures.UpdateDeviceSharing({ ...this.objectSharingParam }));
  }

  acceptShareDvice(item) {
    this.objectSharingParam = {
      ...this.objectSharingParam,
      share_id: item.share_id,
      owner_acode: item.owner_acode,
      is_confirm: true,
    };
    this.store.dispatch(new fromMyfeatures.UpdateDeviceSharing({ ...this.objectSharingParam }));
  }

  rejectSharedGroup(item) {
    this.objectSharingParam = {
      ...this.objectSharingParam,
      share_id: item.data.share_id,
      owner_acode: item.data.owner_acode,
      is_confirm: false,
    };
    this.store.dispatch(new fromMyfeatures.UpdateGroupSharing({ ...this.objectSharingParam }));
  }

  acceptSharedGroup(item) {
    this.objectSharingParam = {
      ...this.objectSharingParam,
      share_id: item.data.share_id,
      owner_acode: item.data.owner_acode,
      is_confirm: true,
    };
    this.store.dispatch(new fromMyfeatures.UpdateGroupSharing({ ...this.objectSharingParam }));
  }

  onTabOpen(event) {
    // const index = event.index;
    // // console.log(index);
    // // 終止預設行為
    // // 終止事件傳導
    // event.stopPropagation();
  }

  errorHandler(event) {
    event.target.classList.add('defaultImg');
    event.target.src = '/assets/images/default_device.png';
  }

  routerCompanion() {
    this.router.navigate(['/companion']);
  }

  ngOnChanges() {
    this.searchKeyWord();
  }

  searchKeyWord() {
    if (this.groupFeature) {
      const filteredDevices = this.deviceListDataStash.filter(item => item.name.toLowerCase().includes(this.keyWord.toLowerCase()));
      this.getNoGroupDevicesPageView(filteredDevices);

      const filteredSharingDevices = this.deviceSharingListDataStash.filter(item => item.name.toLowerCase().includes(this.keyWord.toLowerCase()));
      this.getNoGroupShareDevicesPageView(filteredSharingDevices);

      const filteredGroupDevices = this.deviceGroupListDataStash.map((obj) => {
        const childrenData = obj.children && Array.isArray(obj.children)
        ? obj.children.filter((c) =>
            c.data && c.data.name && c.data.name.toLowerCase().includes(this.keyWord.toLowerCase())
          )
        : [];
      return { data: obj.data, children: childrenData };
      });
      this.getGroupDevicesPageGridView(filteredGroupDevices);

      const filteredShareGroupDevices = this.deviceShareGroupListDataStash.map((obj) => {
        const childrenData = obj.children && Array.isArray(obj.children)
        ? obj.children.filter((c) =>
            c.data && c.data.name && c.data.name.toLowerCase().includes(this.keyWord.toLowerCase())
          )
        : [];
      return { data: obj.data, children: childrenData };
      });
      this.getShareGroupDevicesPageGridView(filteredShareGroupDevices);

    } else {
      const filteredDevices = this.deviceListDataStash.filter(item => item.name.toLowerCase().includes(this.keyWord.toLowerCase()));
      this.getWithoutGroupFeatureView(filteredDevices);
      const filteredSharingDevices = this.deviceSharingListDataStash.filter(item => item.name.toLowerCase().includes(this.keyWord.toLowerCase()));
      this.getWithoutGroupShareFeatureView(filteredSharingDevices);
    }
    if (this.selectedView === 'small-grid') {
      this.dataLoadingView = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {},{}, {}];
    } else {
      this.dataLoadingView = [{}, {}, {}, {}, {}];
    }
  }


  getNoGroupDevicesPageView(data) {
    this.deviceListData = this.sortDeviceGridView(data);
    this.deviceListLength = data.length;
  }

  getNoGroupShareDevicesPageView(data) {
    this.deviceSharingListData = this.sortDeviceGridView(data);
    this.deviceSharingListLength = data.length;
  }

  getWithoutGroupFeatureView(data) {
    this.deviceListData = this.sortDeviceGridView(data);
    this.deviceListLength = data.length;
  }

  getWithoutGroupShareFeatureView(data) {
    this.deviceSharingListData = this.sortDeviceGridView(data);
    this.deviceSharingListLength = data.length;
  }

  getGroupDevicesPageGridView(data) {
    this.deviceGroupListData = this.sortGroupGridView(data);
    this.deviceGroupListLength = data.length;
  }

  getShareGroupDevicesPageGridView(data) {
    this.deviceShareGroupListData = this.sortGroupGridView(data);
    this.deviceShareGroupListLength = data.length;
  }

  sortDeviceGridView (data) {
    return [...data].sort((a: any, b: any) => {
      let value1 = a.name;
      let value2 = b.name;
      return this.sortType ? value1.localeCompare(value2, undefined, { numeric: true })
                           : value2.localeCompare(value1, undefined, { numeric: true });
    });
  }

  sortGroupGridView (data) {
    const sortFunction = (a: any, b: any) => {
      const value1 = a.name;
      const value2 = b.name;
      return this.sortType ? value1.localeCompare(value2, undefined, { numeric: true })
                         : value2.localeCompare(value1, undefined, { numeric: true });
    };
    const groups = data.filter(item => item.data.type === 'Group')
      .sort((a: any, b: any) => sortFunction(a.data, b.data))
      .map((obj) => {
        const childrenData = [...obj.children].sort((a: any, b: any) => sortFunction(a.data, b.data));
        return { data: obj.data, children: childrenData };
      });
    return groups;
  }
}
